import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c6d095b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-coach-players-profile-root-matches" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Utakmice ", -1))
const _hoisted_5 = { class: "action" }
const _hoisted_6 = {
  key: 0,
  class: "box__list"
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "type" }
const _hoisted_10 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "el-button el-button--primary el-button--grey el-button--square",
            to: { name: 'AppCoachPlayersProfileMatchesIndexVue', params: { id: _ctx.$route.params.id } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InfoFilled)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      (_ctx.matches.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matches, (match) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: match.id
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(match.user.content.name) + " " + _toDisplayString(match.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.moment(match.content.date).format('DD.MM.YYYY. - HH:mm')) + " - " + _toDisplayString(match.match_category.content.name), 1)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Nema podataka... "))
    ])
  ]))
}